import request from '@app/utils/apiRequest';
import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {Messages} from "@app/constants/Messages";

export const requestSaveEmployer = (data) => request.post(`employer/save`, data)


export const requestGetEmployerList = (params) => request.get(`employer/list`, {params: params});
export const requestGetEmployer = (params) => request.get(`employer/detail`, {params: params});
